import { render, staticRenderFns } from "./Citacoes.vue?vue&type=template&id=4cb5284b"
import script from "./Citacoes.vue?vue&type=script&lang=js"
export * from "./Citacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports